"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _StandAloneLayout = _interopRequireDefault(require("../../layouts/StandAloneLayout/StandAloneLayout"));
var _LoginFormContainer = _interopRequireDefault(require("./LoginFormContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default() {
  return /*#__PURE__*/_react["default"].createElement(_StandAloneLayout["default"], null, /*#__PURE__*/_react["default"].createElement(_LoginFormContainer["default"], null));
};